import React from 'react'

const RightSide = () => {
  return (
    <div className='w-full h-full flex flex-col items-center justify-end gap-6 text-textLight'>
        <a href='mailto:bunmidavids194@gmail.com'>
            <p className='text-lg rotate-90 w-72 tracking-wide text-textGreen font-logoFont font-bold'>
                Bunmi Oladipupo
            </p>
        </a>
        <span className='w-[2px] h-32 bg-textDark inline-flex'></span>
    </div>
  )
}

export default RightSide